import { addAlert } from './alerts';

function applyStriping(container, selector) {
    if (!container) return;

    const allElements = container.querySelectorAll(selector);
    let visibleIndex = 0;

    allElements.forEach((el) => {
        el.classList.remove('stripe-odd', 'stripe-even');

        const isVisible = window.getComputedStyle(el).display !== 'none';

        if (isVisible) {
            if (visibleIndex % 2 === 0) {
                el.classList.add('stripe-odd');
            } else {
                el.classList.add('stripe-even');
            }
            visibleIndex++;
        }
    });
}

export function applyFieldVisibility(formElement, fieldStates) {
    if (!formElement) return;

    const fieldsContainer = formElement.querySelector('.fields') || formElement;
    const fieldsToToggle = fieldsContainer.querySelectorAll('.form-field');

    fieldsToToggle.forEach((fieldWrapper) => {
        const quantityWidgetContainer = fieldWrapper.querySelector(
            '.quantity-widget-container',
        );
        let fieldName = null;

        if (quantityWidgetContainer) {
            const firstInput = quantityWidgetContainer.querySelector('[name]');
            if (firstInput) {
                const fullFieldName = firstInput.getAttribute('name');
                const parts = fullFieldName.split('_');
                if (
                    parts.length > 1 &&
                    !isNaN(parseInt(parts[parts.length - 1]))
                ) {
                    fieldName = parts.slice(0, -1).join('_');
                } else {
                    fieldName = fullFieldName;
                }
            }
        } else {
            const inputElement = fieldWrapper.querySelector('[name]');
            if (inputElement) {
                fieldName = inputElement.getAttribute('name');
            }
        }

        if (fieldName) {
            if (fieldStates.hasOwnProperty(fieldName)) {
                if (fieldStates[fieldName] === 'N') {
                    fieldWrapper.style.display = 'none';
                } else {
                    fieldWrapper.style.display = '';
                }
            } else {
                fieldWrapper.style.display = '';
            }
        }
    });

    const allFieldsets = fieldsContainer.querySelectorAll('fieldset');
    allFieldsets.forEach((fieldset) => {
        const fieldsInFieldset = fieldset.querySelectorAll('.form-field');

        const isAnyFieldVisible = Array.from(fieldsInFieldset).some(
            (field) => window.getComputedStyle(field).display !== 'none',
        );

        if (isAnyFieldVisible) {
            fieldset.style.display = '';
        } else {
            fieldset.style.display = 'none';
        }

        applyStriping(fieldset, '.form-field');
    });
}

export async function fetchAndApplyVisibility(formElement, configType = 'KEP') {
    if (!formElement) return;
    const groupSelect = formElement.querySelector('#id_group');
    const typeSelect = formElement.querySelector('#id_type');
    const groupValue = groupSelect ? groupSelect.value : null;
    const typeValue = typeSelect ? typeSelect.value : null;

    if (!groupValue) {
        applyFieldVisibility(formElement, {});
        return;
    }

    try {
        const endpoint =
            configType === 'KEU'
                ? '/api/config/keu/field-visibility/'
                : '/api/config/kep/field-visibility/';

        const apiUrl = new URL(endpoint, window.location.origin);
        apiUrl.searchParams.append('group_value', groupValue);
        if (typeValue) {
            apiUrl.searchParams.append('type_value', typeValue);
        }

        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        applyFieldVisibility(formElement, data.field_states);
    } catch (error) {
        console.error('Error fetching field visibility config:', error);
        addAlert(
            'error',
            gettext('Nie udało się wczytać konfiguracji widoczności pól.'),
        );
        applyFieldVisibility(formElement, {});
    }
}
